module.exports = __webpack_public_path__ + "img/welfare_img1.72559ee5.svg";